import axios from 'axios';
import { getImpersonation } from './session';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const imp = getImpersonation();
  if (imp?.token) {
    config.headers.Authorization = `Bearer ${imp.token}`;
  }
  return config;
});

export default api;
